import { z } from 'zod';
import { CoreObjectTypeSchema } from '../inputTypeSchemas/CoreObjectTypeSchema'

/////////////////////////////////////////
// CORE UNREAD ITEM SCHEMA
/////////////////////////////////////////

export const CoreUnreadItemSchema = z.object({
  entityType: CoreObjectTypeSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  rowTimestamp: z.coerce.date(),
  entityId: z.number().int(),
  userId: z.number().int().nullable(),
  deviceToken: z.string().nullable(),
})

export type CoreUnreadItem = z.infer<typeof CoreUnreadItemSchema>

export default CoreUnreadItemSchema;
